(function () {
  const root = document.getElementById('klaviyo-bis');
  if (!root) return;

  const triggerBtn = document.getElementById('bis-button');
  const modal = document.getElementById('bis-modal');
  const form = document.getElementById('bis-form');
  const emailInput = document.getElementById('bis-email');
  const variantInput = document.getElementById('bis-variant-id');
  const msg = document.getElementById('bis-message');
  const submitBtn = document.getElementById('bis-submit');

  const KLAVIYO_PUBLIC_KEY = root.dataset.klaviyoKey || '';

  let lastFocused = null;

  // --- helpers ---
  const parseBool = (v) => String(v).toLowerCase() === 'true';
  function setStatus(text, isError = false) {
    if (!msg) return;
    msg.textContent = text;
    msg.style.display = '';
    msg.style.color = isError ? 'red' : 'inherit';
  }
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  // --- modal controls ---
  function openModal() {
    if (!modal) return;
    lastFocused = document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    emailInput?.focus();
    document.addEventListener('keydown', onKeydown);
  }
  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', onKeydown);
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }
  function onKeydown(e) { if (e.key === 'Escape') closeModal(); }

  modal?.addEventListener('click', (e) => {
    if (e.target === modal || e.target.hasAttribute('data-bis-close')) closeModal();
  });
  modal?.querySelectorAll('[data-bis-close]').forEach((el) => el.addEventListener('click', closeModal));

  // --- core: read from button dataset ---
  function refreshFromButtonDataset() {
    if (!triggerBtn) return;

    const variantId = triggerBtn.dataset.variantId || '';
    const available = parseBool(triggerBtn.dataset.variantAvailable);

    // keep hidden input current
    variantInput.value = variantId;

    // show button only when selected variant is OOS
    if (variantId && !available) {
      triggerBtn.style.display = '';
      triggerBtn.classList.add("visible");

    } else {
      triggerBtn.style.display = 'none';
      triggerBtn.classList.remove("visible");
      // if variant becomes available while modal is open, close it
      if (modal?.classList.contains('is-open')) closeModal();
    }

    // clear any old status
    msg.style.display = 'none';
    msg.textContent = '';
    msg.style.color = 'inherit';
  }

  // initial pass
  refreshFromButtonDataset();

  // watch for attribute changes your theme makes
  if (window.MutationObserver && triggerBtn) {
    const mo = new MutationObserver((muts) => {
      for (const m of muts) {
        if (m.type === 'attributes' && m.attributeName?.startsWith('data-')) {
          refreshFromButtonDataset();
          break;
        }
      }
    });
    mo.observe(triggerBtn, { attributes: true, attributeFilter: [
      'data-variant-id', 'data-variant-available',
      'data-variant-title','data-variant-sku','data-variant-price',
      'data-variant-image','data-product-id','data-product-handle','data-inventory-qty'
    ]});
  }

  // optional: expose a direct API your theme can call
  window.BIS_refresh = refreshFromButtonDataset;

  // open modal
  triggerBtn?.addEventListener('click', () => {
    // guard: only open if OOS and we have a variant id
    const hasId = !!triggerBtn.dataset.variantId;
    const isAvailable = parseBool(triggerBtn.dataset.variantAvailable);
    if (hasId && !isAvailable) openModal();
  });

  // submit to Klaviyo (email-only)
  form?.addEventListener('submit', async (e) => {
    e.preventDefault(window.themeVariables.strings.success);

    const email = (emailInput?.value || '').trim();
    const variantId = (variantInput?.value || '').trim();

    if (!KLAVIYO_PUBLIC_KEY) { setStatus('Missing Klaviyo public key.', true); return; }
    if (!variantId) { setStatus(window.themeVariables.strings.error_sov, true); return; }
    if (!validEmail(email)) { setStatus(window.themeVariables.strings.error_valid_email, true); emailInput?.focus(); return; }

    submitBtn.disabled = true;
    setStatus('Submitting…');

    try {
      const res = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(KLAVIYO_PUBLIC_KEY)}`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          'revision': '2025-10-15' // <-- add this (use a valid published revision)
        },
        credentials: 'omit',
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: { data: { type: 'profile', attributes: { email } } }
            },
            relationships: { variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${variantId}` } } }
          }
        })
      });

      if (res.status === 202) {
        setStatus();
        const keepId = variantId; form.reset(); variantInput.value = keepId;
      } else if (res.status === 409) {
        setStatus(window.themeVariables.strings.error_already);
      } else {
        const text = await res.text().catch(() => '');
        setStatus(window.themeVariables.strings.error, true);
      }
    } catch {
      setStatus(window.themeVariables.strings.error, true);
    } finally {
      submitBtn.disabled = false;
    }
  });
})();